module.exports = __webpack_public_path__ + "static/media/990816.eb40c3ff.png";